var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 5.33333C8.00001 4.59696 8.59696 4 9.33334 4C10.0697 4 10.6667 4.59696 10.6667 5.33333C10.6667 6.0697 10.0697 6.66666 9.33334 6.66666C8.59696 6.66666 8.00001 6.0697 8.00001 5.33333ZM13.3333 5.33333C13.3333 4.59696 13.9303 4 14.6667 4C15.4031 4 16 4.59696 16 5.33333C16 6.0697 15.4031 6.66666 14.6667 6.66666C13.9303 6.66666 13.3333 6.06971 13.3333 5.33333ZM8 12C8 11.2636 8.59696 10.6666 9.33333 10.6666C10.0697 10.6666 10.6667 11.2636 10.6667 12C10.6667 12.7363 10.0697 13.3333 9.33333 13.3333C8.59696 13.3333 8 12.7363 8 12ZM13.3333 12C13.3333 11.2636 13.9303 10.6666 14.6667 10.6666C15.4031 10.6666 16 11.2636 16 12C16 12.7363 15.4031 13.3333 14.6666 13.3333C13.9303 13.3333 13.3333 12.7363 13.3333 12ZM8 18.6666C8 17.9302 8.59696 17.3333 9.33333 17.3333C10.0697 17.3333 10.6667 17.9302 10.6667 18.6666C10.6667 19.403 10.0697 19.9999 9.33333 19.9999C8.59696 19.9999 8 19.403 8 18.6666ZM13.3333 18.6666C13.3333 17.9302 13.9303 17.3333 14.6666 17.3333C15.4031 17.3333 16 17.9302 16 18.6666C16 19.403 15.4031 19.9999 14.6666 19.9999C13.9303 19.9999 13.3333 19.403 13.3333 18.6666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.f4cb3aa92bf81a49a4ef7861eda4a387.svg";
export { ForwardRef as ReactComponent };